import { AutoComplete, Input } from 'antd';
import React, { ReactElement, useEffect, useState } from 'react';
import { FETCH_SUB_GEO } from '../../../shared/constants/commonConstants';
import { CityOption } from '../../../shared/models/hospitalProfile.model';
import SendRequest from '../../../shared/services/sendRequest.service';

const CityAutoComplete = ({ onCitySelect, stateId, dValue }: any): ReactElement => {
  const [cities, setCities] = useState([] as any[]);
  const [value, setValue] = useState(dValue);
  useEffect((): void => {
    if (stateId) {
      fetchAllCities();
      setValue('');
      setCities([]);
    } else if (dValue) {
      setCities([]);
    } else {
      setCities([]);
      setValue('');
    }
    // eslint-disable-next-line
  }, [stateId]);

  const fetchAllCities = async (): Promise<void> => {
    const request: any = {
      id: stateId,
      lookUpLevel: 2,
    };
    const cityResponse: any = await SendRequest.instance.post(process.env.REACT_APP_BASE_URL + FETCH_SUB_GEO, request);
    if (cityResponse && cityResponse.isSuccess && cityResponse.keywordLookupDetails && cityResponse.keywordLookupDetails.length) {
      setCities(cityResponse.keywordLookupDetails.map((city: CityOption): CityOption => {
        return { id: city.id, value: city.name };
      }));
    }
  };

  const onStateFilter = (inputValue: string, option: any): boolean =>
    option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1;

  const onSelect = (e: string): void => {
    const [city] = cities.filter((stateOption: any): boolean => stateOption.value === e);
    onCitySelect(city);
  };

  const onFocus = (event: any): void => {
    if (event.target.autocomplete) {
      event.target.autocomplete = 'autocomplete';
    }
  };

  const onchange = (e: any): void => {
    setValue(e);
    if (e === '') {
      onCitySelect(null);
    }
  };

  return (
    <AutoComplete value={value}
      // tslint:disable-next-line:no-unused-expression
      onChange={onchange}
      disabled={!stateId}
      filterOption={onStateFilter} options={cities} placeholder="City" onSelect={onSelect}>
      <Input autoComplete="off" onFocus={onFocus} />
    </AutoComplete>
  );
};

export default CityAutoComplete;
